import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as _ from "lodash";
import { MatTableDataSource } from '@angular/material';
import { JobHoursModelComponent } from "src/app/time-sheet/learner-single-week/job-hours-model/job-hours-model.component";
import * as moment from "moment";
// import { TimesheetApprovalModalComponent } from "src/app/labour-job/timesheet-approval-modal/timesheet-approval-modal.component";
// import { _clientTimesheetApprovalModalData } from "../../_models/staticArray";
// import { _clientTimesheetRejectionModalData } from "../../_models/staticArray";
import { _adminTimesheetApprovalModalData } from "../../_models/staticArray";
import { _adminTimesheetRejectionModalData } from "../../_models/staticArray";
import { animate, state, style, transition, trigger, } from "@angular/animations";
import { UtilityService } from 'src/app/services/utility.service';
import { LabourJobService } from '../labour-job.service';
import { UserTimeSheetService } from 'src/app/services/user-time-sheet.service';
import { TimeSheetService } from '../../services/time-sheet.service';
import { CommentsComponent } from 'src/app/commons/comments/comments.component';

@Component({
  selector: "timesheet-approval",
  templateUrl: "./timesheet-approval.component.html",
  styleUrls: ["./timesheet-approval.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({ height: "0px", minHeight: "0", visibility: "hidden" })
      ),
      state("expanded", style({ height: "*", visibility: "visible" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class TimesheetApprovalComponent implements OnInit {
  loading: boolean;
  noSubFolderMsg = {
    title: "No Logs found!",
    data: "Can not find any logs.",
  };
  singleJobDetail;
  timelogs: any = [];
  isDownload: boolean = false;
  isDataSourceAvailable: boolean = true;
  dataSource: MatTableDataSource<any>;
  labourJobTitleColumn = ["title"];
  labourJobDateColumn = ["date"];
  mainlogIndex: any;
  copiedIndex: any;
  showPasteBtn: boolean = false;
  user = JSON.parse(localStorage.getItem("userRoles"));
  logsColumns = [
    "Approve",
    "Copy",
    "JobTitle",
    "Clients",
    "Operatives",
    "Planned Start",
    "Actual Start",
    "Planned End",
    "Actual End",
    "Travel Hours",
    "Hours Worked",
    "Travel + Working",
    "Status",
    "Edit",
    "Reset",
    "Remark",
    'expand'
  ];
  timelogStatusList = [
    { value: "all", viewValue: "All" },
    { value: "pending", viewValue: "Pending" },
    { value: "approved", viewValue: "Approved" },
  ];
  selectedTimelog = [];
  timelogStatus: string = "all";
  selectedFilter;
  selectedJob;
  selectedClient;
  selectedOperative;
  selectedWeek;
  currenWeekData
  dateMapping = {
    Saturday: [0, 6],
    Sunday: [1, 5],
    Monday: [2, 4],
    Tuesday: [3, 3],
    Wednesday: [4, 2],
    Thursday: [5, 1],
    Friday: [6, 0],
  };
  labourjobList = []
  clientList = []
  operativeList = []
  currenWeekDates = []
  weekStartDate;
  weekEndDate;
  expandedElement: any;
  weekDateList = []
  isApproved = false
  constructor(
    public _utilityService: UtilityService,
    public _labourjobService: LabourJobService,
    public _userTimeSheetService: UserTimeSheetService,
    public _timeSheetService: TimeSheetService,
    public _cd: ChangeDetectorRef
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    // this.dataSource = new MatTableDataSource([]);
    if (this.user.isClient) {
      this.logsColumns = ["Approve", "JobTitle",
        "Clients",
        "Operatives",
        "Planned Start",
        "Actual Start",
        "Planned End",
        "Actual End",
        "Travel Hours",
        "Hours Worked",
        "Travel + Working",
        "Status",
        "Edit",
        // "Reset",
        "Remark",
        "expand",
      ];
    }
    this.getWeeksDates();
    this.getTimesheetFilterList();
    this.getWeeknumberwithDates()
  }

  /**
   * This function will gives a current week dates for the first time only.
   */
  getWeeksDates() {
    this.loading = true;
    let obj = {
      _isWeek: true
    }
    this._timeSheetService.getRailWeekDates(obj).subscribe((data) => {
      console.log("DATA OF CURRENT WEEK", data)
      this.currenWeekDates = data[0].dateList
      this.selectedWeek = data[0]._id
      this.getJobsListForApproval({ dates: this.currenWeekDates });
    }, error => {
      console.log("ERROR WHILE GET RAIL WEEK DATES", error)
    })
  }

  // API CALL




  downloadStaffReport() {
    this.isDownload = true;
    console.log("DOWNLOAD ALL STAFF REPORT FOR ONE WEEK", this.currenWeekDates)
    this._userTimeSheetService.downloadStaffReport({ dates: this.currenWeekDates }).subscribe((data) => {
      console.log("THIS IS THE STAFF REPORT DATA", data)
      const downloadLink = document.createElement("a");
      downloadLink.href = data;
      downloadLink.download = `ALL STAFF REPORT`
      downloadLink.click();
      this.isDownload = false;
      this._utilityService.handleSnackBar({ msg: 'Download Successfully', button: 'OK' })
    }, error => {
      console.log("ERROR WHILE DOWNLOAD STAFF REPORT", error)
      this.isDownload = false;
    })
  }

  getTimesheetFilterList() {
    this._labourjobService.getTimesheetFilterList().subscribe((data) => {
      console.log("FILTER LIST DATA FOR TIMESHEET PAGE", data);
      this.labourjobList = data.jobList;
      this.clientList = data.clientList;
      this.operativeList = data.operativeList;
    });
  }

  filterOnGo() {
    console.log("SELECTED JOB FILTER DATA", this.selectedJob)
    console.log("SELECTED CLIENT FILTER DATA", this.selectedClient)
    console.log("SELECTED OPERATIVE FILTER DATA", this.selectedOperative)
    console.log("STATUS FILTER", this.selectedWeek)
    let tempWeek = this.weekDateList.find((x) => x._id === this.selectedWeek)
    console.log("THIS IS THE TEMP WEEK DATA", tempWeek)
    let obj = {
      // dates: this.currenWeekDates
    }
    if (tempWeek != undefined) {
      obj['dates'] = tempWeek.dateList
      this.selectedWeek = tempWeek._id
      this.currenWeekData = tempWeek
      this.weekStartDate = this.currenWeekData.startDate
      this.weekEndDate = this.currenWeekData.endDate
    }
    if (this.selectedJob && this.selectedJob.length) obj['jobs'] = this.selectedJob
    if (this.selectedClient && this.selectedClient.length) obj['clients'] = this.selectedClient
    if (this.selectedOperative && this.selectedOperative.length) obj['operatives'] = this.selectedOperative
    if (this.selectedFilter !== undefined) obj['status'] = this.timelogStatus
    this.getJobsListForApproval(obj)
  }

  getWeeknumberwithDates() {
    this._timeSheetService.getRailWeekDates({}).subscribe((data) => {
      console.log("THIS IS THE LIST OF WEEK DATES", data, this.selectedWeek)
      this.weekDateList = data
      this.currenWeekData = this.weekDateList.find((x) => x._id == this.selectedWeek)
      console.log("THIS IS THE SELECTED WEEK DATA", this.currenWeekData, this.selectedWeek, this.weekDateList)
      this.weekStartDate = this.currenWeekData.startDate
      this.weekEndDate = this.currenWeekData.endDate
    }, error => {
      console.log("ERROR WHILE GET WEEK DATES", error)
    })
  }


  getJobsListForApproval(data: any) {
    console.log("DATA OF FILTER", data)
    this.loading = true;
    this._labourjobService
      .getJobsForApproval(data)
      .subscribe(
        (jobList) => {
          this.loading = false;
          console.log("jobList for Approval : ", jobList);
          if (jobList.timeLogs && jobList.timeLogs.length) {
            this.isDataSourceAvailable = true;
            this.timelogs = jobList.timeLogs;
            this.dataSource = this.timelogs;
          } else {
            this.isDataSourceAvailable = false;
          }
          // if (jobList.currentWeek) {
          //   this.selectedWeek = jobList.currentWeek._id
          //   if (this.weekDateList && this.weekDateList.length) {
          //     this.currenWeekData = this.weekDateList.find((x) => x._id == this.selectedWeek)
          //     this.weekStartDate = this.currenWeekData.startDate
          //     this.weekEndDate = this.currenWeekData.endDate
          //   }
          // this._cd.detectChanges()
          // }
        },
        (error) => {
          console.log("error while getting jobs for Approval : ", error);
          this.isDataSourceAvailable = false;
        }
      );
  }



  checkAllTimelogs(event) {
    const logs = this.timelogs;
    for (let i = 0; i < logs.length; i++) {
      if (event && event.checked === true) {
        console.log("SINGLE LOG", logs[i])
        // logs[i].patchValue({ checked: true })
        if (logs[i].timelogs && logs[i].timelogs.length) {
          const timeLogLength = logs[i].timelogs.length
          for (let j = 0; j < timeLogLength; j++) {
            if (!logs[i].timelogs[j].isDisable) {
              logs[i].timelogs[j].checked = true;
              const obj = {
                logId: logs[i].timelogs[j]._id,
                userId: logs[i].timelogs[j].userId,
                status: logs[i].timelogs[j].status,
                date: logs[i].timelogs[j].date
              };
              // if (logs[i].timelogs[j] && logs[i].timelogs[j].job) {
              //   obj['job'] = logs[i].timelogs[j].job
              // }
              this.selectedTimelog.push(obj);
            } else {
              logs[i].timelogs[j].checked = false;
            }
          }
        }
      }
      else {
        if (logs[i].timelogs && logs[i].timelogs.length) {
          const timeLogLength = logs[i].timelogs.length
          for (let j = 0; j < timeLogLength; j++) {
            logs[i].timelogs[j].checked = false;
          }
        }
      }
    }

    if (event && event.checked === true && this.selectedTimelog && this.selectedTimelog.length) {
      this.isApproved = true
      // this.submitTimelogForApproval()
    }
    if (this.selectedTimelog && !this.selectedTimelog.length && event && event.checked === true) {
      this._utilityService.openSnackBar("No logs are eligible for Approval.", "OK");
    }

    console.log("SUBMITTEED LOGS", this.selectedTimelog)

  }

  checkSelectionTimelog(event, item) {
    console.log("Event :--: ", event);
    console.log("item :--: ", item);
    if (event && event.checked === true) {
      const obj = {
        logId: item._id,
        userId: item.userId,
        status: item.status,
        date: item.date,
      };
      if (item && item.jobDetail) {
        obj['jobId'] = item.jobDetail._id
      }
      this.selectedTimelog.push(obj);
    } else {
      const index = _.findIndex(this.selectedTimelog, function (o) {
        return o.logId === item._id && o.date === item.date;
      });
      this.selectedTimelog.splice(index, 1);
    }
    console.log("this.selectedTimelog :: ", this.selectedTimelog);
  }

  copyCurrentLogs(mainIndex: number, i: number) {
    console.log('mainIndex :: ', mainIndex)
    console.log("Checking :: ", i);
    this.copiedIndex = i;
    this.mainlogIndex = mainIndex;
    this.showPasteBtn = true;
  }

  pasteLogs(mainIndex, childIndex, singleLog) {
    const preObj = this.timelogs[this.mainlogIndex].timelogs[this.copiedIndex];
    const currentObj = this.timelogs[mainIndex].timelogs[childIndex];
    console.log("preObj ::: ", preObj);
    console.log("currentObj ::: ", currentObj);
    let multipleExpenseList = []
    if (preObj.multipleExpense && preObj.multipleExpense.length) {
      preObj.multipleExpense.filter((x) => {
        multipleExpenseList.push({
          expenseType: x.expenseType,
          expenseAmount: x.expenseAmount,
          expenseEvidence: x.expenseEvidence,
          // expenseDate: this._userTimeSheetService.covertDateFormate(currentObj.date, 'MM/DD/YYYY'),
          expenseDate: currentObj.date,
          userId: x.userId
        })
      })
    }
    let multipleDeductionList = []
    if (preObj.multipleDeduction && preObj.multipleDeduction.length) {
      preObj.multipleDeduction.filter((x) => {
        multipleDeductionList.push({
          deductionType: x.deductionType,
          deductionAmount: x.deductionAmount,
          deductionDate: currentObj.date,
          // deductionDate: this._userTimeSheetService.covertDateFormate(currentObj.date, 'MM/DD/YYYY'),
          userId: x.userId
        })
      })
    }
    currentObj["start"] = preObj.start;
    currentObj["end"] = preObj.end;
    currentObj["travel"] = preObj.travel;
    currentObj["workingHours"] = preObj.workingHours;
    currentObj["workingColor"] = preObj.workingColor;
    currentObj["totalHours"] = preObj.totalHours;
    currentObj["totalColor"] = preObj.totalColor;
    currentObj['details'] = preObj.details
    currentObj['multipleLogs'] = preObj.multipleLogs
    currentObj['multipleExpense'] = multipleExpenseList
    currentObj['multipleDeduction'] = multipleDeductionList
    currentObj['date'] = currentObj.date
    // if (preObj.jobId) currentObj["jobId"] = preObj.jobId;
    console.log("preObj : ", preObj);
    console.log("currentObj : ", currentObj);
    this.dataSource[mainIndex].timelogs[childIndex] = currentObj;
    this.showPasteBtn = false;
    this._utilityService.handleSnackBar({
      msg: "Logs will be updated after you save.",
      button: "OK",
    });
  }

  edit(data) {
    console.log("THIS IS THE DATA", data)
    data['extraDetails'] = data.details && data.details.extraDetails ? data.details.extraDetails : ''
    data['livingAllowance'] = data.details && data.details.livingAllowance ? data.details.livingAllowance : false
    data['payRate'] = data.details && data.details.payRate ? data.details.payRate : ''
    data['paidHours'] = data.details && data.details.paidHours ? data.details.paidHours : false
    data['expense'] = data.details && data.details.expense ? data.details.expense : false
    data['deduction'] = data.details && data.details.deduction ? data.details.deduction : false
    data['date'] = moment(data.date).format("DD/MM/YYYY")
    let obj = {
      data: { value: data },
      name: data.operativeName,
      clientList: this.clientList,
      // deletedLog: this.deletedLog,
      learner: data.userId,
      previousDayLog: [],
      // previousDayLog: this.getPreviousDayLog(val.value, i),
      isInstructor: true,
      type: "adminSheet",
      isName: true,
    };

    // currentJob: data.jobDetail._id /** @note to add Timelog for particular JobId for Timesheet Approval */,


    if (data && data.jobDetail) {
      obj['currentJob'] = data.jobDetail._id /** @note to add Timelog for particular JobId for Timesheet Approval */
    }

    console.log("Data send for approval in timesheet approval : ", data);
    this._utilityService
      .commonDialogBoxOpen(JobHoursModelComponent, obj)
      .afterClosed()
      .subscribe((added) => {
        console.log("ADDED", added);
        if (added == undefined) {
          data['date'] = this._userTimeSheetService.covertDateFormate(data.date, 'MM/DD/YYYY')
          return;
        }
        else {
          // this._utilityService.handleSnackBar({ msg: "Logs will be paste after save!", button: "OK" })
          // this.addCalculation.emit({ isCal: true })
          // this.getTimeLogs();
          this.getWeeksDates();
        }
      });
  }

  resetCurrentLogs(mainIndex, index) {
    const currentObj = this.dataSource[mainIndex].timelogs[index];
    console.log("currentObj :: ", currentObj);
    currentObj["start"] = "00:00";
    currentObj["end"] = "00:00";
    currentObj["travel"] = "00:00";
    currentObj["workingHours"] = "00:00";
    currentObj["workingColor"] = "green";
    currentObj["totalHours"] = "00:00";
    currentObj["totalColor"] = "green";
    currentObj["multipleExpense"] = [];
    currentObj["multipleLogs"] = [];
    currentObj["details"] = {};
    this.dataSource[mainIndex].timelogs[index] = currentObj;
  }

  addComent(mainIndex, dayData, dayIndex) {
    console.log("Checking dayData : ", dayData);
    console.log("Checking dayData mainIndex : ", mainIndex);
    console.log("Checking dayData dayIndex : ", dayIndex);
    let data = {
      isRemark: true,
      userId: dayData.userId,
      logId: dayData._id,
      remarks: dayData.remarks || [],
      date: moment(dayData.date).format("DD/MM/YYYY"),
      urlDate: moment(dayData.date).format("DD-MM-YYYY"),
      notificationData: {
        clientList: dayData.jobDetail.clients,
        jobId: dayData.jobDetail._id,
        mainIndex: mainIndex,
      },
      isTimesheet: true
    };
    this._utilityService
      .commonDialogBoxOpen(
        CommentsComponent,
        data,
        "100vh",
        "100vh"
      )
      .afterClosed()
      .subscribe((commentAdded) => {
        console.log("commentAdded", commentAdded);
        if (commentAdded == undefined) return;
        else {
          if (commentAdded.success) {
            console.log("REMARK ADD FOR SPECIFIC DATA", commentAdded);
            console.log(
              "this.dataSource[mainIndex] : ",
              this.dataSource[mainIndex]
            );
            console.log(
              "this.dataSource[mainIndex] with day index : ",
              this.dataSource[mainIndex].timelogs[dayIndex]
            );
            // const subObjIndex = this.timelogs[
            //   mainIndex
            // ].logs.findIndex((y) => y.index === dayIndex);
            // console.log("SUBOBJECT INDEX", subObjIndex);
            let latestComment = commentAdded.success.data.logs.find(
              (x) => x._id == dayData._id
            );
            console.log("LATEST COMMENT DATA", latestComment);
            this.dataSource[mainIndex].timelogs[dayIndex].remarks = latestComment.remarks;
            // this.dataSource[mainIndex].logs[subObjIndex].log["remarks"] =
            //   latestComment.remarks;
            console.log("DATA SOURCE AFTER UPDATE", this.dataSource);
            // this._utilityService.handleSnackBar({ msg: "Comment Added Successfully", button: "OK" })
          }
          if (commentAdded.error) console.log("THIS IS FOR ERROR");
        }
      });
  }

  downloadTimesheet() {
    this.isDownload = true;
    console.log("CURRENWEEK", this.currenWeekData)
    let obj = {
      // dates: this.currenWeekData.dateList,
      // timelogs: {timelogs: this.mergeTimelogs(this.timelogs)},
      start_date: this.currenWeekData.startDate,
    };



    // saveAs('https://uktps.s3.eu-west-2.amazonaws.com/fullPath.xlsx', 'title');

    this._userTimeSheetService.downloadTimesheet(this.currenWeekData.startDate)
      .subscribe(
        (data) => {
          console.log("THIS IS THE TIME SHEET DATA TO DOWNLOAD", data);
          const downloadLink = document.createElement("a");
          downloadLink.href = data.filePath;
          downloadLink.click();
          this.isDownload = false;
        },
        (error) => {
          console.log("ERROR0 ", error);
          this.isDownload = false;
        }
      );
  }


  mergeTimelogs(timelogs) {
    console.log("THIS IS TIEMLOGS ARRAY", timelogs)
    let timeLogsList = []
    for (let i = 0; i < timelogs.length; i++) {
      timeLogsList = timeLogsList.concat(timelogs[i].timelogs)
    }
    return timeLogsList
  }


  filterTimelogStatus(status) {
    console.log("status ::: ", status);
    if (status === "all") {
      this.dataSource = this.timelogs;
      this.timelogStatus = "all";
      this.isDataSourceAvailable = true;
    } else {
      if (this.user.isOperative) {
        this.timelogStatus = status;
      } else if (this.user.isClient) {
        if (status === "pending") this.timelogStatus = "approval1";
        else if (status === "approved") this.timelogStatus = "approval2";
      } else if (this.user.isAdmin) {
        if (status === "pending") this.timelogStatus = "submitted";
        else if (status === "approved") this.timelogStatus = "approved";
      }

      this.selectedFilter = status
    }
  }

  filterTimeloList() {
    console.log("timelogStatus ::: ", this.timelogStatus);
    if (this.timelogStatus == "all") {
      this.dataSource = this.timelogs;
      this.isDataSourceAvailable = true;
    } else {
      let tempDateList = JSON.parse(JSON.stringify(this.timelogs));
      let filteredTimelogList: any = [];
      tempDateList.forEach((timelog) => {
        let _timelog = { ...timelog };
        let _logs = [];
        timelog.logs.forEach((logs) => {
          if (logs.log.status === this.timelogStatus) _logs.push(logs);
        });
        _timelog.logs = _logs;
        if (_logs.length > 0) filteredTimelogList.push(_timelog);
      });
      console.log("checking filteredTimelogList :: ", filteredTimelogList);
      if (filteredTimelogList.length) {
        this.dataSource = filteredTimelogList;
        this.isDataSourceAvailable = true;
      } else {
        this.isDataSourceAvailable = false;
      }
    }
  }

  submitAllTimelogForApproval() {
    console.log("submitAllTimelogForApproval : ", this.timelogs);
    this.selectedTimelog = [];
    for (let i = 0; i < this.timelogs.length; i++) {
      let timelogs = this.timelogs[i];
      for (let j = 0; j < timelogs.timelogs.length; j++) {
        /** @note if Admin submit all timelogs then status should be submitted */
        if (this.user && (this.user.isAdmin || this.user.isManager) && timelogs.timelogs[j].status === 'submitted') {
          const obj = {
            logId: timelogs.timelogs[j]._id,
            userId: timelogs.timelogs[j].userId,
            status: timelogs.timelogs[j].status,
            date: timelogs.timelogs[j].date,
            // jobId: timelogs.timelogs[j].jobDetail._id, /** @notes adding jobs in individual timelogs for approval. */
          };
          if (timelogs.timelogs[j] && timelogs.timelogs[j].jobDetail) {
            obj['jobId'] = timelogs.timelogs[j].jobDetail._id
          }
          this.selectedTimelog.push(obj);
        } else if (this.user && this.user.isClient && timelogs.timelogs[j].status === 'approval1') {
          /** @note if Client submit all timelogs then status should be approval1 */
          const obj = {
            logId: timelogs.timelogs[j]._id,
            userId: timelogs.timelogs[j].userId,
            status: timelogs.timelogs[j].status,
            date: timelogs.timelogs[j].date,
            jobId: timelogs.timelogs[j].jobDetail._id /** @notes adding jobs in individual timelogs for approval. */,
          };
          this.selectedTimelog.push(obj);
        }
      }
    }
    console.log("this.selectedTimelog : ", this.selectedTimelog);
    if (this.selectedTimelog && this.selectedTimelog.length) {
      this.submitTimelogForApproval();
    } else {
      this._utilityService.handleSnackBar({
        msg: "No logs are eligible for Approval.",
        button: "Ok",
      });
    }
  }

  getUniquedate(logs) {
    console.log("LOGS DATA TO BE CONSIDER", logs)
    let datesArray = []
    const logsLength = logs.length
    for (let index = 0; index < logsLength; index++) {
      const element = datesArray.find((x) => x === moment(logs[index].date).format("DD-MM-YYYY"))
      console.log("ELEMENT DATA", element, moment(logs[index].date).format("DD-MM-YYYY"))
      if (element == undefined) datesArray.push(moment(logs[index].date).format("DD-MM-YYYY"))
    }
    return datesArray
  }

  /**
   * This function is for submitting the timelogs for approval.
   * timelog status will be updated according to which user approved Timelogs.
   */
  submitTimelogForApproval() {
    let modalContent;
    let next_action;
    // if (this.user.isClient) {
    //   // modalContent = _clientTimesheetApprovalModalData;
    //   next_action = "approval2";
    // } else {
    modalContent = _adminTimesheetApprovalModalData;
    next_action = "approved";
    // }
    let data = {
      modalContent: modalContent,
      timeLogs: this.selectedTimelog,
      displayDates: this.getUniquedate(this.selectedTimelog),
      isApproval: true,
    };
    this._utilityService
      .commonDialogBoxOpen(CommentsComponent, data)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const payload = {
            logs: this.selectedTimelog,
            // jobId: this.currentJob,
            next_action: next_action,
          };
          console.log("checking payload for approval :: ", payload);
          this._labourjobService
            .submitTimelogForApproval(payload, false)
            .subscribe(
              (data) => {
                // this.filterTimeloList();
                this.selectedTimelog = [];
                if (this.isApproved) {
                  this.isApproved = false
                }
                // this.getWeeksDates();
                this.getJobsListForApproval({ dates: this.currenWeekDates });
                this._utilityService.openSnackBar(
                  "Logs are submitted for Approval!",
                  "OK"
                );
              },
              (error) => {
                console.log("Error from updating timelogs : ", error);
                this._utilityService.handleSnackBar({
                  msg: "Something went wrong",
                  button: "Ok",
                });
              }
            );
        } else { /** @note hanlded modal with cancel response. */
          this.selectedTimelog = [];
          this.isApproved = false
          let logs = this.timelogs
          for (let i = 0; i < logs.length; i++) {
            // console.log("SINGLE LOG", logs[i])
            if (logs[i].timelogs && logs[i].timelogs.length) {
              const timeLogLength = logs[i].timelogs.length
              for (let j = 0; j < timeLogLength; j++) {
                logs[i].timelogs[j].checked = false;
              }
            }
          }
        }
      });
  }

  /**
   * This function will reject Timelog.
   * Only Operative and Admin can reject the Timelog.
   */
  submitTimelogForRejection() {
    let modalContent;
    if (this.user.isClient) {
      // modalContent = _clientTimesheetRejectionModalData;
    } else {
      modalContent = _adminTimesheetRejectionModalData;
    }
    let data = {
      modalContent: modalContent,
      timeLogs: this.selectedTimelog,
      isApproval: true,
    };
    const dialogRef = this._utilityService
      .commonDialogBoxOpen(CommentsComponent, data)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          console.log("THIS IS THE SELECTED LOGS", this.selectedTimelog)
          const newList = this.selectedTimelog.map(({ date, ...rest }) => {
            return rest;
          });
          console.log("AFTER NEW LIST CREATED", newList)
          const payload = {
            logs: this.selectedTimelog,
            // jobId: this.currentJob,
            next_action: "reject",
          };
          this._labourjobService
            .submitTimelogForApproval(payload, false)
            .subscribe(
              (data) => {
                this.selectedTimelog = [];
                // this.getWeeksDates();
                this.getJobsListForApproval({ dates: this.currenWeekDates });
                this._utilityService.openSnackBar("Logs are successfully rejected and moved for operative resubmission.", "OK");
              },
              (error) => {
                console.log("Error from updating timelogs : ", error);
                this._utilityService.handleSnackBar({
                  msg: "Something went wrong",
                  button: "Ok",
                });
              }
            );
        } else {

        }
      });
  }

  fatigueIndexCalculation(user) {
    // console.log("current selected user", user);
    if (this.user.isOperative) {
      const data = {
        userId: user.userId,
        type: "fatigue",
      };
      // console.log("this is the data to be send", data);
      this._userTimeSheetService
        .getFatigueIndex(JSON.stringify(data))
        .subscribe(
          (response) => {
            // console.log("response of fatigue index", response);
            // this.isCalculation = true
            // this.addCalculation.emit({ isCal: true });
          },
          (err) => {
            // console.log("error while get fatigue index", err);
          }
        );
    }
  }

  /**
   * @param weekStartDate first day of the currenct week
   * @param weekEndDate last day of the currenct week.
   * @returns dates array of mentioned start & end date.
   */
  getDatesArray(weekStartDate: moment.Moment, weekEndDate: moment.Moment) {
    let dates = [];
    dates.push(weekStartDate.format("MM/DD/YYYY"));
    while (weekStartDate.add(1, "days").diff(weekEndDate) <= 0) {
      dates.push(weekStartDate.clone().format("MM/DD/YYYY"));
    }
    this.weekStartDate = dates[0];
    this.weekEndDate = dates[dates.length - 1];
    return dates;
  }

  /**
   * This function will gives previous week dates array according to the current week selected.
   */
  previous() {
    // let weekStartDate = moment(this.weekStartDate).add(-7, "days");
    // let weekEndDate = moment(this.weekStartDate).add(-1, "days");
    // let dates = this.getDatesArray(weekStartDate, weekEndDate);
    console.log("THIS IS THE CURRENT WEEK", this.currenWeekData)
    let index = this.weekDateList.findIndex((x) => x._id == this.currenWeekData._id)
    this.selectedWeek = this.weekDateList[index - 1]._id
    this.currenWeekData = this.weekDateList.find((x) => x._id == this.selectedWeek)
    this.weekStartDate = this.currenWeekData.startDate
    this.weekEndDate = this.currenWeekData.endDate
    // this.getJobsListForApproval({ dates: this.weekDateList[index - 1].dateList });
    let obj = {}
    obj['dates'] = this.weekDateList[index - 1].dateList
    this.currenWeekDates = this.weekDateList[index - 1].dateList
    if (this.selectedJob && this.selectedJob.length) obj['jobs'] = this.selectedJob
    if (this.selectedClient && this.selectedClient.length) obj['clients'] = this.selectedClient
    if (this.selectedOperative && this.selectedOperative.length) obj['operatives'] = this.selectedOperative
    if (this.selectedFilter !== undefined) obj['status'] = this.timelogStatus
    console.log("CURRENT WEEK DATES DATA", this.currenWeekDates)
    this.getJobsListForApproval(obj);
  }

  /**
   * This funciton will gives next week dates array according to the current week selected.
   */
  next() {
    // let weekStartDate = moment(this.weekEndDate).add(1, "days");
    // let weekEndDate = moment(this.weekEndDate).add(7, "days");
    // let dates = this.getDatesArray(weekStartDate, weekEndDate);
    // this.selectedWeek = ''
    // this.getJobsListForApproval({ dates });


    // this.selectedWeek = data[0]._id

    console.log("THIS IS THE CURRENT WEEK", this.currenWeekData)
    console.log("ALL WEEK DATE LIST DATA", this.weekDateList)
    let index = this.weekDateList.findIndex((x) => x._id == this.currenWeekData._id)
    this.selectedWeek = this.weekDateList[index + 1]._id
    console.log("WHAT is the index", index, this.selectedWeek, this.weekDateList[index + 1])
    this.currenWeekData = this.weekDateList.find((x) => x._id == this.selectedWeek)
    this.weekStartDate = this.currenWeekData.startDate
    this.weekEndDate = this.currenWeekData.endDate
    this._cd.detectChanges()
    let obj = {}
    obj['dates'] = this.weekDateList[index + 1].dateList
    this.currenWeekDates = this.weekDateList[index + 1].dateList
    if (this.selectedJob && this.selectedJob.length) obj['jobs'] = this.selectedJob
    if (this.selectedClient && this.selectedClient.length) obj['clients'] = this.selectedClient
    if (this.selectedOperative && this.selectedOperative.length) obj['operatives'] = this.selectedOperative
    if (this.selectedFilter !== undefined) obj['status'] = this.timelogStatus
    console.log("CURRENT WEEK DATES DATA", this.currenWeekDates)
    this.getJobsListForApproval(obj);
  }

  submitDetail() {
    let logsArray = [];
    for (let i = 0; i < this.timelogs.length; i++) {
      for (let j = 0; j < this.timelogs[i].timelogs.length; j++) {
        let singleDate = this.timelogs[i].timelogs[j];
        if (!singleDate.isDisable) {
          console.log("SINGLE DATE LOG DATA", singleDate)
          let temp = {
            _id: singleDate._id,
            details: {},
            // date: singleDate.date,
            date: singleDate.date,
            hours: singleDate.hours,
            minutes: singleDate.minutes,
            workingHours: singleDate.workingHours,
            start: singleDate.start,
            end: singleDate.end,
            // jobId: singleDate.jobDetail._id,
            job: singleDate.job,
            status: singleDate.status,
            travel: singleDate.travel,
            totalHours: singleDate.totalHours,
            userId: singleDate.userId,
            remarks: singleDate.remarks,
            multipleLogs: singleDate.multipleLogs,
            multipleExpense: singleDate.multipleExpense,
            multipleDeduction: singleDate.multipleDeduction,
          };
          temp.details = {
            extraDetails: singleDate.details.extraDetails,
            livingAllowance: singleDate.details.livingAllowance,
            payRate: singleDate.details.payRate,
            paidHours: singleDate.details.paidHours,
            expense: singleDate.details.expense,
            deduction: singleDate.deduction,
          }
          logsArray.push(temp);
        }
      }
    };
    console.log("THIS IS THE LOGS ARRAY TO BE UPDATE : ", logsArray);
    let finalArray = [];
    if (logsArray && logsArray.length) {
      const logsLength = logsArray.length;
      for (let i = 0; i < logsLength; i++) {
        let obj = {
          date: [],
          learner: logsArray[i].userId,
          type: "adminSheet",
          jobId: logsArray[i].jobId,
        };
        let index = finalArray.findIndex(
          (x) => x.learner == logsArray[i].userId
        );
        if (index != -1) {
          finalArray[index].date.push(logsArray[i]);
        } else {
          obj.date = [logsArray[i]];
          finalArray.push(obj);
        }
      }
    }
    console.log("OUT PUT OF LOG ARRAY TO BE ADDED", finalArray);
    this._labourjobService
      .addmultipleUserslogs(finalArray)
      .subscribe((data) => {
        console.log("DATA is updated", data);
        this.getJobsListForApproval({ dates: this.currenWeekDates });
        this._utilityService.openSnackBar("Logs added successfully!", "OK");
      });
  }
}
